export default {
  "profile": {
    "personalDetailsSections": "Sezioni dei dati personali",
    "middleNameS": "Nome(i)",
    "preferredDisplayName": "Nome del display/preferito",
    "leaveBlankIfNotApplicable": "Lasciare vuoto se non applicabile.",
    "mobileNumber": "Numero di cellulare",
    "allergyDetails": "Dettagli allergia",
    "dietaryLifestyleNotes": "Note dietetiche/lifestyle",
    "searchActiveClubMembers": "Cerca soci del club attivo",
    "nameOrMembershipNumber": "Nome o numero di iscrizione",
    "selectedMemberIsMy": "Il socio selezionato è il mio",
    "membershipStatus": "Stato socio",
    "currentAvatar": "Avatar attuale",
    "mr": "Signor Presidente, signor Commissario.",
    "mrs": "Interrogazione n.",
    "miss": "Signorina.",
    "ms": "Signora",
    "dr": "Dr. Dr.",
    "prof": "Prof. Prof. Prof. Prof. Prof.",
    "sir": "Signore.",
    "dame": "Diga",
    "lord": "Signore",
    "lady": "Signora",
    "rev": "Rev.",
    "work": "Lavoro",
    "holidayHome": "Casa vacanza",
    "postal": "Postale",
    "car": "Carrozzeria",
    "motorcycle": "Moto",
    "van": "Van Van Van Van Van Van",
    "golfBuggy": "Golf cart",
    "grandparent": "Nonno",
    "grandchild": "Granchio",
    "dependant": "Dipendente",
    "label": "Etichetta",
    "addressType": "Tipo di indirizzo",
    "addressLine1": "Indirizzo linea 1",
    "addressLine2": "Indirizzo linea 2",
    "townOrCity": "Città o città",
    "countyStateOrRegion": "Contea, Stato o regione",
    "postcodeOrZIPCode": "Codice postale o CAP",
    "country": "Paese",
    "registrationLicencePlate": "Registrazione / targa",
    "make": "Fai come vuoi",
    "model": "Modello",
    "colour": "Colore",
    "vehicleType": "Tipo di veicolo",
    "fullName": "Nome completo",
    "relationship": "Relazioni",
    "alternativeTelephone": "Telefono alternativo",
    "emailAddress": "Indirizzo email",
    "otherDietaryRequirement": "Altri requisiti alimentari",
    "recreational": "Ricreazione",
    "social": "Sociale",
    "club": "Club Club",
    "competitive": "Competitività",
    "elite": "Elite Elite",
    "discardChanges": "Eliminare i cambiamenti?",
    "youHaveUnsavedChanges": "Hai delle modifiche non salvate.",
    "ifYouContinueYourChangesWillBeLost": "Se continui, i tuoi cambiamenti saranno persi.",
    "discard": "Cartolina",
    "removeFamilyRelationship": "Rimuovere la relazione di famiglia?",
    "thisWillRemoveTheFamilyRelationshipForBothMembers": "Questo rimuoverà il rapporto di famiglia per entrambi i membri.",
    "thisActionCannotBeUndoneAutomatically": "Questa azione non può essere annullata automaticamente.",
    "keepRelationship": "Mantenere la relazione",
    "removeVehicle": "Rimuovere il veicolo?",
    "removeAddress": "Rimozione dell'indirizzo?",
    "thisVehicleWillBeRemovedFromYourProfile": "Questo veicolo verrà rimosso dal tuo profilo.",
    "thisAddressWillBeRemovedFromYourProfile": "Questo indirizzo verrà rimosso dal tuo profilo.",
    "saveChanges": "Salva le modifiche",
    "sending": "Invio…",
    "sendRequest": "Invia richiesta",
    "removing": "Rimozione...",
    "confirming": "Conferma in corso…",
    "accepting": "Accettare...",
    "confirmRemoval": "Confermare la rimozione",
    "acceptRelationship": "Accettare la relazione",
    "keeping": "Mantenere...",
    "rejecting": "Rifiutare...",
    "reject": "Rifiuti",
    "removalRequest": "Richiesta di rimozione",
    "cancelling": "Cancelliere...",
    "cancelRequest": "Annulla richiesta",
    "addVehicle": "Aggiungi veicolo",
    "addAddress": "Aggiungi l'indirizzo",
    "mainPostalAddress": "Indirizzo postale principale",
    "saveVehicle": "Risparmio di veicoli",
    "saveAddress": "Salva l'indirizzo",
    "primary": "Primario",
    "uploading": "Caricamento...",
    "uploadNewPhoto": "Carica nuova foto",
    "updated": "Aggiornato.",
    "memberNumberUnavailable": "Numero socio non disponibile",
    "enterAtLeastTwoCharactersToFindAnActive": "Inserisci almeno due caratteri per trovare un socio del club attivo.",
    "keepTypingToSearchActiveClubMembers": "Continua a digitare per cercare i soci del club attivo.",
    "noMatchingMembersFound": "Nessun socio corrispondente trovato.",
    "hasRequestedToRemoveYourFamilyRelationship": "Ha richiesto di rimuovere la vostra relazione con la famiglia.",
    "hasRequestedToAddYouAsTheirRelation": "Ha richiesto di aggiungerti come loro {relation} .",
    "relationRelationshipRequest": "{relation} relazione richiesta",
    "unableToRemoveVehicle": "Incapace di rimuovere il veicolo.",
    "unableToRemoveAddress": "Non è possibile rimuovere l'indirizzo.",
    "weCouldNotSaveYourChangesYourEditsAre": "Non possiamo salvare le modifiche. Le tue modifiche sono ancora qui. Si prega di riprovare.",
    "weCouldNotLoadYourDetailsPleaseTryAgain": "Non potevamo caricare i tuoi dati, per favore riprova.",
    "yourSessionOrAccessCouldNotBeVerifiedPlease": "La sessione o l'accesso non possono essere verificati. Si prega di accedere di nuovo o contattare il club.",
    "thisServiceIsUnavailablePleaseReopenTheAppOr": "Questo servizio non è disponibile. Si prega di riaprire l'app o contattare il club.",
    "pleaseCheckTheHighlightedFieldsAndTryAgain": "Si prega di controllare i campi evidenziati e riprovare.",
    "saved": "Salvata.",
    "yourChangesWereSavedButTheProfileSummaryCould": "Le modifiche sono state salvate, ma il riepilogo del profilo non potrebbe rinfrescarsi.",
    "refreshSummary": "Riepilogo dei rifiuti",
    "enterAValidEmailAddress": "Inserisci un indirizzo email valido",
    "enterAValidTelephoneNumber": "Inserisci un numero di telefono valido",
    "invalidDate": "Data non valida",
    "dateCannotBeInTheFuture": "La data non può essere in futuro",
    "enterAMoreRecentDate": "Inserisci una data più recente",
    "addressLine1TownCityAndCountryAreRequired": "Indirizzo linea 1, città / città e paese sono richiesti",
    "registrationIsRequired": "La registrazione è richiesta",
    "htmlIsNotAllowed": "HTML non è consentito",
    "maximumCountCharacters": "Massimo {count} caratteri",
    "pleaseSelectAnImageFile": "Selezionare un file di immagine",
    "pleaseChooseAnImageUnder8MB": "Si prega di scegliere un'immagine sotto 8MB",
    "unableToRemovePhoto": "Incapace di rimuovere la foto",
    "unableToSavePortraitPreferenceRightNow": "Incapace di salvare le preferenze del ritratto in questo momento.",
    "enter00360OrUseForA": "Inserire 0,0–36.0, o utilizzare + per un handicap più fino a +5,0.",
    "profilePhotoUpdated": "Foto del profilo aggiornata.",
    "ready": "Pronto",
    "yourPortraitIsNowLive": "Il tuo ritratto ora e' vivo.",
    "weArePreparingYourPortrait": "Stiamo preparando il tuo ritratto.",
    "profilePhotoRemoved": "Foto del profilo rimossa.",
    "notSet": "Non impostato",
    "addYourLevelForBetterMatchesAndRecommendations": "Aggiungi il tuo livello per le migliori partite e raccomandazioni.",
    "handicap": "Handicappati",
    "levelNumber": "Livello {number}",
    "notSaved": "Non salvato",
    "setLevel": "Imposta il livello",
    "currentHandicap": "Disabilità attuale",
    "currentTier": "Tirolo attuale",
    "golfHandicap": "handicap golf",
    "preparing": "Preparare...",
    "bringProfileToLife": "Portare il profilo alla vita",
    "switchToPhoto": "Passare alla foto",
    "switchToLivePortrait": "Passare al ritratto vivo",
    "livePortrait": "Ritratto dal vivo",
    "sportPlayingLevel": "{sport} livello di gioco",
    "golfHandicapNumber": "handicap golf {number}",
    "sportTierLevelNumber": "{sport} , {tier} livello, livello {number}",
    "handicapNumber": "Handicap {number}",
    "nameLivePortrait": "{name} ritratto dal vivo",
    "viewPhoto": "Visualizza foto",
    "viewLivePortrait": "Visualizza ritratto dal vivo",
    "tierLevel": "{tier} livello"
  },
  "dining": {
    "somethingWentWrongPleaseTryAgain": "Qualcosa e' andato storto, per favore riprovate.",
    "thatTableTimeWasJustBookedPleaseChooseAnother": "L'orario del tavolo era appena prenotato. Si prega di scegliere un altro tempo disponibile.",
    "chooseAValidDateAndTimeInYourClub": "Scegli una data e l'ora validi nel fuso orario del tuo club.",
    "thisReservationIsNowInsideTheClubSCancellation": "Questa prenotazione è ora all'interno della finestra di cancellazione del club. Si prega di contattare il club.",
    "yourMemberSessionHasExpiredPleaseSignInAgain": "La tua sessione è scaduta. Si prega di iscriversi di nuovo.",
    "youAppearToBeOfflineCheckYourConnectionAnd": "Sembri offline, controlla la tua connessione e riprova.",
    "thisPartySizeIsNotSupportedForOnlineReservations": "Questa dimensione del partito non è supportato per le prenotazioni on-line.",
    "thisDiningAreaIsNotTakingReservationsOnThe": "Questa zona pranzo non richiede prenotazioni alla data selezionata.",
    "theSelectedDateOrTimeIsInsideTheMinimum": "La data o l'ora selezionata è all'interno del periodo minimo di preavviso.",
    "onlineReservationsAreNotCurrentlyAvailableForThisDining": "Le prenotazioni on-line non sono attualmente disponibili per questa zona pranzo.",
    "weCouldnTCheckTableAvailabilityPleaseTryAgain": "Non siamo riusciti a controllare la disponibilità del tavolo.",
    "noTablesAreAvailableForThatDateTryAnother": "Non sono disponibili tavoli per quella data, prova un'altra volta o una data.",
    "diningReservationsAreNotCurrentlyAvailable": "Le prenotazioni per i pasti non sono attualmente disponibili.",
    "someDiningInformationCouldNotBeRefreshed": "Alcune informazioni culinarie non potrebbero essere aggiornate.",
    "weCouldnTReadTheAvailableTimesPleaseTry": "Non abbiamo potuto leggere i tempi disponibili. Si prega di riprovare.",
    "yourReservationCouldNotBeCompleted": "La vostra prenotazione non potrebbe essere completata.",
    "theReservationCouldNotBeCancelled": "La prenotazione non poteva essere cancellata.",
    "confirmed": "Confermato",
    "seated": "Seduta",
    "noShow": "Assente",
    "diningArea": "Zona pranzo",
    "dismissError": "Discorso di errore",
    "loadingDiningAreas": "Zone pranzo di carico",
    "removeOneGuest": "Rimuovi un ospite",
    "addOneGuest": "Aggiungi un ospite",
    "loadingAvailableTimes": "Caricamento dei tempi disponibili",
    "findAvailableTables": "Trova tabelle disponibili",
    "yourSearchWasNotTreatedAsAnEmptyResult": "La tua ricerca non è stata trattata come un risultato vuoto.",
    "tryNearbyTimesAnotherDateOrAdjustYourParty": "Provare gli orari vicini, un'altra data, o regolare la dimensione del partito.",
    "changeDate": "Modifica della data",
    "allergiesAccessibilityRequirementsBirthdaysOrAnniversaries": "Allergie, requisiti di accessibilità, compleanni o anniversari...",
    "reservingYourTable": "Conservare il vostro tavolo...",
    "updateReservation": "Aggiornamento Prenotazione",
    "reserveTable": "Tabella di riserva",
    "loadingReservations": "Caricamento in corso",
    "noPreviousReservations": "Nessuna precedente prenotazione",
    "closeReservationDetails": "Chiudere i dettagli della prenotazione",
    "diningAreaUnavailable": "Zona pranzo non disponibile",
    "unavailable": "Non disponibile",
    "onlineCancellationIsAvailable": "La cancellazione online è disponibile.",
    "submitted": "presentato",
    "nameDiningArea": "{name} zona pranzo",
    "countGuest": "{count} ospiti",
    "countGuests": "{count} ospiti",
    "countRecent": "{count} recente",
    "timeUnavailable": "Tempo non disponibile",
    "dateUnavailable": "Data non disponibile",
    "chooseADiningAreaDateAndValidPartySize": "Scegli una zona pranzo, la data e la dimensione del partito valida.",
    "countRecentOne": "{count} recente"
  },
  "golf": {
    "preparingYourRound": "Preparare il tuo giro",
    "gettingCoursesAndPlayersReady": "Preparare percorsi e giocatori",
    "loadingScoringTees": "Caricamento in corso",
    "loadingActiveRounds": "Caricamento di giri attivi",
    "golfCourse": "Campo da golf",
    "startingRound": "A partire da...",
    "startRound": "Iniziare il giro",
    "deleteRound": "Cancella tutto",
    "course": "Percorso",
    "golfSetupStep": "Configurazione golf: {step}",
    "strokePlay": "Gioco di tiro",
    "countEveryStrokeAcrossTheRound": "Contare ogni ictus attraverso il giro.",
    "stableford": "Stableford",
    "playForPointsOnEveryHole": "Gioca per punti su ogni buco.",
    "nameTees": " · {name} tees",
    "weCouldnTStartTheRoundNothingHasBeen": "Non abbiamo potuto iniziare il round. Nulla è stato registrato — si prega di riprovare.",
    "deleteCourseRound": "Elimina {course} round",
    "guestName": "Ospite — {name}",
    "removeName": "Rimuovi {name}",
    "today": "Oggi",
    "yesterday": "Ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri, ieri sera, ieri sera, ieri, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri sera, ieri, ieri",
    "checkingSportAvailability": "Controllare la disponibilità sportiva",
    "loadingClubSports": "Carico club sport",
    "findingWhatSAvailableToday": "Trovare ciò che è disponibile oggi",
    "playARound": "Gioca un round",
    "takeToTheCourt": "Andate in campo.",
    "loadingLetSPlay": "Caricamento Giochiamo",
    "weCouldnTLoadThisCompletedActivity": "Non potevamo caricare questa attività completata.",
    "momentFromName": "Momento da {name}",
    "round": "tondo",
    "activity": "attività",
    "countHoles": "{count} buche · ",
    "countHoles225": " · {count} buche",
    "round226": "Tondo",
    "round227": "Tondo",
    "preparingYourActivitySummary": "Preparazione del riepilogo delle attività",
    "loadingActivity": "Attività di carico",
    "roundCOMPLETE": "GIRO COMPLETATO",
    "countBirdie": "{count} Birdie",
    "countBirdies": "{count} Uccelli",
    "countEagle": "{count} Aquila",
    "countEagles": "{count} Aquile",
    "countAlbatross": "{count} albatros",
    "countAlbatrosses": "{count} albatrosse",
    "countHoleInOne": "{count} buca in uno",
    "countHolesInOne": "{count} buche in uno",
    "weCouldnTLoadYourHistory": "Non potevamo caricare la tua storia.",
    "countHoles240": " · {count} buche",
    "round241": "Tondo",
    "round242": "Tondo",
    "birdie": "BIRDIE",
    "nicelyJudged": "Bellamente giudicato.",
    "cleanWork": "Lavoro pulito.",
    "oneBetter": "Uno migliore.",
    "thatLlPlay": "Questo giocherà.",
    "eagle": "GESTIONE",
    "thatLlDo": "Questo lo farà.",
    "twoBetterVeryTidy": "Meglio due, molto ordinato.",
    "nowWeReTalking": "Ora stiamo parlando.",
    "exceptional": "Eccezionale.",
    "albatross": "ALBATROSS",
    "wellThatEscalated": "Beh, questo e' aumentato.",
    "threeUnderAbsurd": "Tre sotto.",
    "youDonTSeeThatEveryDay": "Non lo vedi ogni giorno.",
    "ridiculousInTheBestWay": "Ridicolo, nel modo migliore.",
    "holeINONE": "BUCA IN UNO",
    "oneSwingThatSAllItTook": "Un'altalena. E' tutto quello che ci ha messo.",
    "someoneSBuyingTheDrinks": "Qualcuno sta comprando i drink.",
    "straightInTheHistoryBook": "Dritto nel libro della storia.",
    "perfectlyUnnecessarySecondShot": "Perfettamente inutile secondo colpo.",
    "titleForName": "{title} per {name} .",
    "preparingYourMoment": "Preparare il tuo momento...",
    "continueAfterTitleForName": "Proseguire dopo {title} per {name}",
    "thisRoundWillBeRemovedFromLetSPlay": "Questo round sarà rimosso da Let’s Play e non sarete in grado di continuare a segnarlo."
  }
}
